<template>
  <main id="main-content" class="categorized-products">
    <div>
        <div class="products-category main-img main-video">
            <video class="wp-block-cover__video-background" autoplay="" muted="" loop=""
                   :src="shop_main_video_url"></video>
            <h1 class="video-label" v-if="shop_main_video_text">{{ shop_main_video_text }}</h1>
        </div>
      <section
        class="products-category"
        v-for="category in categorized_products_data"
        :key="category.id"
      >
        <h2>{{ category.name }}</h2>

        <div class="products-category-list">
          <CategorizedProduct
            v-for="(product) in category.products"
            :key="product.id"
            v-bind:product_data="product"
          />
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import CategorizedProduct from "@/components/CategorizedProduct.vue";

export default {
  name: "CategorizedProducts",
  components: {
    CategorizedProduct,
  },
  data() {
    return {
      quantity: 0,
      order_count: 1,
      shop_main_image_url: window.APP_INFO.init.shop_main_image_url,
      shop_main_video_url: window.APP_INFO.init.shop_main_video_url,
      shop_main_video_text: window.APP_INFO.init.shop_main_video_text,
      selected_variant_id: null,
      gallery: {
        style: {
          backgroundImage: "none",
        },
        current_image_index: 0,
      },
    };
  },
  props: {
    categorized_products_data: {
      type: Array,
      required: false,
    },
  },
  created() {
    console.log(this.categorized_products_data[2]);
  },
};
</script>